import React from 'react';
import clsx from 'clsx';

import styles from './CheckboxSmall.module.scss';

export enum CheckboxSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
}

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string | JSX.Element;
  size?: CheckboxSize;
  checkboxLabelClassName?: string;
  withShadow?: boolean;
}

const CheckboxSmall = ({
  className,
  label,
  onChange,
  checked,
  disabled = false,
  size = CheckboxSize.Xl,
  checkboxLabelClassName,
  withShadow = false,
  ...rest
}: CheckboxProps) => (
  <div className={className}>
    <label className={clsx(styles.container, styles[`container__${size}`])}>
      <div className={clsx(styles.checkboxLabel, checkboxLabelClassName)}>{label}</div>
      <input type="checkbox" {...rest} onChange={onChange} checked={checked} disabled={disabled} />
      <span
        className={clsx(
          styles.checkmark,
          disabled && styles.disabled,
          styles[`checkmark__${size}`],
          withShadow && styles.checkmarkWithShadow,
        )}
      />
    </label>
  </div>
);

export default CheckboxSmall;
